function BluHomeConfiguration() {
    this.__type = 'BluHomeConfiguration:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.CallInPeriod = -1;
    this.DoReset = false;
	this.EnrolleeId = -1;
	this.InitializeFingerprint = 0;
	this.GracePeriod = -1;
    this.InRangeCount = -1;
    this.OriginatingPhoneNumber = null;
    this.RfRange = -1;
    this.TrackingDeviceId = -1;
    this.UserId = -1;
    this.CommandType = -1;
    this.TopMessage = '';
    this.BottomMessage = '';
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = BluHomeConfiguration;
}